export default __webpack_public_path__ + "static/media/videoOnNew.b3668ad6.svg";